import { useQuery } from "@tanstack/react-query";
import {
	GetAuthAccountQuery,
	GetAuthAccountQueryVariables,
} from "~auth/types/__generated/gql/graphql";
import { gqlReqNext } from "~utils/api/gql-req/next";

const query = /* GraphQL */ `
	query GetAuthAccount {
		getCurrentAccount {
			id
			createdAt
			updatedAt
			companyName
			slug
			partnerId
			isPastDue
			_partner {
				id
				companyName
				contactEmail
			}
			subscription {
				type
				trialExpiresAt
				paidConfig {
					cycle
					plan
					addons {
						admins
						editors
						maps
						storage
					}
					subscriptionID
				}
			}
			_currentUserRole
			_quotaUsage {
				mapsUsed
				mapsLimit
				storageBytesUsed
				storageBytesLimit
				viewersUsed
				viewersLimit
				isViewersUnlimited
				adminsUsed
				adminsLimit
				editorsUsed
				editorsLimit
				isAddOnsAllowed
			}
			_recurlyAccountInfo {
				subscription {
					collectionMethod
					plan
					addOns {
						code
						quantity
					}
				}
				hostedToken
				paymentMethod {
					cardType
					lastFour
					expMonth
					expYear
				}
				billingAddress {
					vatNumber
					firstName
					lastName
					streetLine1
					streetLine2
					city
					province
					country
					postalCode
					companyName
				}
			}
			portalConfig {
				name
				defaultLayout
				bannerTitle
				bannerContent
				footer
				navigation {
					isEnabled
					items {
						isEnabled
						label
						type
						linkConfig {
							url
							isOpenInNewTab
						}
						emailConfig {
							email
							subject
							body
						}
						termsConfig {
							content
						}
						modalConfig {
							title
							content
						}
					}
				}
			}
			brandingConfig {
				logoUrl
				presetTheme
				primaryColor
				highlightColor
				removeBranding
				ga4MeasurementId
			}
			subdomain
		}
	}
`;

export const getAuthAccountQueryKey = () => ["getAuthAccount"];

const getAuthAccountQueryFn = async (signal?: AbortSignal) => {
	return gqlReqNext<GetAuthAccountQuery, GetAuthAccountQueryVariables>({
		query,
		signal,
	});
};

/**
 * @deprecated: Avoid using this directly, access current auth account via AuthContext instead.
 */
export const useGetAuthAccount = () => {
	return useQuery({
		queryKey: getAuthAccountQueryKey(),
		queryFn: ({ signal }) => getAuthAccountQueryFn(signal),
	});
};
